var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tk-container',{attrs:{"status":_vm.status}},[(_vm.privacyNotice)?_c('div',{staticClass:"agreement-box",domProps:{"innerHTML":_vm._s(_vm.privacyNotice)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }